import React, { useMemo } from 'react';
import { Layout, RendererProps, UISchemaElement, WithClassname } from '@jsonforms/core';
import { twJoin } from 'tailwind-merge';
import { useJsonForms } from '@jsonforms/react';
import { getTrueFields } from '../../utils/getTrueFields';

type LayoutRendererProps = RendererProps &
  WithClassname & {
    dark?: boolean;
  };

type ExtendedLayout = Layout & {
  label?: string;
};
export type ExtendedUISchemaElement = UISchemaElement & {
  scope?: string;
};

export const GroupRenderer: React.FC<LayoutRendererProps> = ({ schema, uischema, dark }) => {
  const ctx = useJsonForms();
  const data = ctx.core?.data;
  const layout = uischema as ExtendedLayout;

  const trueFields = useMemo(
    () => getTrueFields(layout.elements as ExtendedUISchemaElement[], schema, data),
    [layout.elements, schema, data]
  );

  return (
    <div>
      {layout.label && (
        <div
          className={twJoin(
            'border-brightGray mb-3 flex gap-[8px] rounded-md border p-[12px]',
            dark ? 'bg-pageBackgroundDark border-chineseBlack text-white' : 'bg-[#F6F9FF]'
          )}
        >
          <div className="qc-form-label text-1824 font-medium capitalize">{layout.label}</div>
        </div>
      )}
      <div
        className={twJoin(
          'text-1624 rounded-md border p-[12px] font-medium',
          dark ? 'bg-arsenic border-chineseBlack text-white' : 'border-brightGray'
        )}
      >
        {trueFields?.length ? (
          <div className={'text-1624 font-medium'}>{trueFields.join(', ')}</div>
        ) : (
          <div className={'text-1624 font-medium'}>no data</div>
        )}
      </div>
    </div>
  );
};
